import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAdminData } from '../hooks/useAdminData';
import AdminStats from '../components/admin/AdminStats';
import AdminUserTable from '../components/admin/AdminUserTable';
import AdminUserDrawer from '../components/admin/AdminUserDrawer';
import './AdminPage.css';

const AdminPage: React.FC = () => {
  const navigate = useNavigate();
  const { users, stats, loading, error, forbidden, refresh } = useAdminData();
  const [selectedUserId, setSelectedUserId] = useState<string | null>(null);

  // The server is the real gate — require_admin returns 403. This redirect is
  // presentation only, which is why it reacts to the API's answer rather than
  // fetching the role separately first.
  useEffect(() => {
    if (forbidden) navigate('/onboarding', { replace: true });
  }, [forbidden, navigate]);

  return (
    <div className="admin-page">
      <div className="admin-inner">
        <p className="admin-eyebrow">Admin</p>
        <h1 className="admin-title">Users</h1>
        <p className="admin-lead">All signed-up users and their purchase status.</p>

        {loading && <p className="admin-muted">Loading…</p>}
        {error && !loading && <p className="admin-error">{error}</p>}

        {!loading && stats && <AdminStats stats={stats} />}

        {!loading && users && users.length > 0 && (
          <AdminUserTable
            users={users}
            selectedUserId={selectedUserId}
            onSelect={setSelectedUserId}
          />
        )}

        {!loading && users && users.length === 0 && (
          <p className="admin-muted">No users found.</p>
        )}

        <p className="admin-footer-note">
          <Link to="/video-upload" className="admin-link">Back to app</Link>
        </p>
      </div>

      {selectedUserId && (
        <AdminUserDrawer
          key={selectedUserId}
          userId={selectedUserId}
          onClose={() => setSelectedUserId(null)}
          onChanged={refresh}
        />
      )}
    </div>
  );
};

export default AdminPage;
